import * as React from 'react';
import { Box, Stack, Typography, Zoom } from '@mui/material';
import { green, red } from '@mui/material/colors';
import ParentBox from 'pages/components/ParentBox';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import ApiService from 'services/ApiService';
import AlignCenterBox from 'components/AlignCenterBox';
import { ResponsivePie } from '@nivo/pie';
import { dashboardTheme } from 'utils/nivoConfig';

// const PieDemo = ({ chartData, title }) => {
//     return (
//         chartData &&
//         // <StrechBox width={300} height={300} sx={{ position: 'relative', width: '100%', height: '100%' }}>
//         // <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
//         <Box sx={{ position: 'relative', width: 550, height: 520 }}> 
//             {title && <AlignCenterBox>
//                 <Typography variant='h3' textAlign={'center'}>{title}</Typography>
//                 <Typography variant='h4' textAlign={'center'} color={'limegreen'}>
//                     {(chartData[0].value / (chartData[0].value + chartData[1].value) * 100).toFixed(1)}%
//                 </Typography>
//             </AlignCenterBox>}
//             <ResponsivePie
//                 theme={{
//                     text: {
//                         fontSize: '2em',
//                         fontWeight:'300',
//                         fill: `#FFFFFF`,
//                         }
//                     }
//                 }
//                 data={chartData}
//                 sortByValue
//                 margin={{ top: 50, right: 50, bottom: 80, left: 50 }}
//                 colors={[green[600], red[700]]}
//                 innerRadius={0.85}
//                 padAngle={2.5}                
//                 cornerRadius={40}
//                 enableArcLabels={false}
//                 //arcLinkLabel="label"
//                 arcLinkLabel={d => `${d.id}: ${d.value}`}
//                 activeOuterRadiusOffset={5}
//                 //enableArcLinkLabels={false}
//                 arcLinkLabelsSkipAngle={1}
//                 //arcLinkLabelsStraightLength={4}
//                 arcLinkLabelsDiagonalLength={30}
//                 arcLinkLabelsTextColor="#ffffff"
//                 arcLinkLabelsThickness={4}
//                 arcLinkLabelsColor={{ from: 'color' }}
//                 arcLabelsRadiusOffset={0.65}
//                 arcLabelsSkipAngle={10}
//                 isInteractive={false}
//             />
//         </Box>
//         // </StrechBox>
//     )
// }

const PieDemo = ({ chartData, title }) => {
    return (
        chartData &&
        <Box sx={{ position: 'relative', width: 550, height: 520 }}>
            {title && (
                <AlignCenterBox>
                    <Typography variant='h3' textAlign={'center'}>{title}</Typography>
                    <Typography variant='h4' textAlign={'center'} color={'limegreen'}>
                        {(chartData[0].value / (chartData[0].value + chartData[1].value) * 100).toFixed(1)}%
                    </Typography>
                </AlignCenterBox>
            )}
            {/* <ResponsivePie
                data={chartData}
                theme={{
                    text: {
                        fontSize: '2em',
                        fontWeight: '300',
                        fill: '#FFFFFF',
                    }
                }}
                sortByValue
                margin={{ top: 50, right: 50, bottom: 80, left: 50 }}
                colors={[green[600], red[700]]}
                innerRadius={0.6} // ✅ 도넛 두껍게
                padAngle={0}
                cornerRadius={5}
                enableArcLabels={false}
                enableArcLinkLabels={true} // ✅ 꼬다리 다시 켬
                arcLinkLabel={d => `${d.id}: ${d.value}`} // ✅ 정상/장애 건수 표출
                arcLinkLabelsSkipAngle={1}
                arcLinkLabelsDiagonalLength={30}
                arcLinkLabelsTextColor="#ffffff"
                arcLinkLabelsThickness={4}
                arcLinkLabelsColor={{ from: 'color' }}
                isInteractive={false}
                

                borderWidth={0}
                borderColor={{ from: 'color', modifiers: [['darker', 1]] }}
            /> */}


            <ResponsivePie
                data={chartData}
                animate={true}
                margin={{ top: 50, right: 50, bottom: 80, left: 50 }}
                innerRadius={0.6}
                padAngle={1.5}
                cornerRadius={3}
                colors={[green[600], red[700]]}
                borderWidth={0}
                borderColor={{ from: 'color', modifiers: [['darker', 0.3]] }}
                theme={{
                    text: {
                        fontSize: '2em',
                        fontWeight: '300',
                        fill: '#FFFFFF',
                    }
                }}
                // arcLinkLabelsSkipAngle={1}
                // arcLinkLabelsTextColor="#999"
                // arcLinkLabelsThickness={4}
                // arcLinkLabelsColor={{ from: 'color' }}
                // arcLabelsSkipAngle={10}
                // arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 3]] }}
                // // enableArcLinkLabels={false}
                // enableArcLabels={true}
                enableArcLabels={false}
                enableArcLinkLabels={true} // ✅ 꼬다리 다시 켬
                arcLinkLabel={d => `${d.id}: ${d.value}`} 
                arcLinkLabelsSkipAngle={1}
                arcLinkLabelsDiagonalLength={30}
                arcLinkLabelsTextColor="#ffffff"
                arcLinkLabelsThickness={4}
                arcLinkLabelsColor={{ from: 'color' }}
                isInteractive={false}

            />
        </Box>
    );
}

const GridTextDisplayComponent = ({ checked, data }) => {
    return (
        data &&
        <Stack sx={{ height: '100%', width: '100%' }}
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={3}>
            {/* <Zoom in={checked} style={{ transitionDelay: checked ? '1000ms' : '0ms' }}> */}
            <Zoom in={checked}>
                <Box sx={{ width: '100%', height: '90%' }}>
                    <PieDemo chartData={data.chartData} title={data.title} />
                </Box>
            </Zoom>
            {/* {[
                { title: '함체문 열림', value: data.value1 },
                { title: '프로세스 장애', value: data.value2 },
                { title: '표출 장애', value: data.value3 },
            ].map((info, idx) => <GridLineItemComponet key={idx}
                title={info.title} value={info.value} enableColorCheck={idx === 2} />)} */}

        </Stack>
    )
}

export default function BisFacilityStatusView() {
    const [currentData, setCurrentData] = React.useState()
    const [checked] = React.useState(true);

    React.useEffect(() => {
        return repeatEffect(
            async () => {
                const response = await ApiService.get("dashboard/bis/GetFacilityStatus");
                if (response.status === 200) {
                    const data = response.data;
                    if (data) {
                        const created = [{
                            title: 'LED',
                            chartData: [{ id: '정상', value: data.ledUseCnt }, { id: '장애', value: data.ledCommFail }],
                            value1: data.ledDoorOpen, value2: data.procLedErr, value3: data.ledMonFail
                        },
                        {
                            title: 'LCD',
                            chartData: [{ id: '정상', value: data.lcdUseCnt }, { id: '장애', value: data.lcdCommFail }],
                            value1: data.lcdDoorOpen, value2: data.procLcdErr, value3: data.lcdMonFail
                        }
                        // {
                        //     title: 'KIOSK',
                        //     chartData: [{ id: '정상', value: data.kioskUseCnt }, { id: '장애', value: data.kioskCommFail }],
                        //     value1: data.kioskDoorOpen, value2: data.procKioskErr, value3: data.kioskMonFail
                        // }
                        ]

                        setCurrentData(created)
                    }
                }
            },
            settingsConfig().contentUpdateDelaySec)
    }, []);

    return (
        <ParentBox title={'BIS 시설물 상태 모니터링'}>
            <Box sx={{ height: '100%', width: '100%', p: -5 }}>
                <Stack sx={{ height: '100%', width: '100%' }}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}>
                    <GridTextDisplayComponent sx={{ height: '100%', width: '100%' }} data={currentData && currentData[0]} checked={checked} />
                    <GridTextDisplayComponent sx={{ height: '100%', width: '100%' }} data={currentData && currentData[1]} checked={checked} />
                    <GridTextDisplayComponent sx={{ height: '100%', width: '100%' }} data={currentData && currentData[2]} checked={checked} />
                </Stack>
            </Box>
        </ParentBox>
    )
}

// import * as React from 'react';
// import { Box, Stack, Typography, Zoom } from '@mui/material';
// import { green, red } from '@mui/material/colors';
// import ParentBox from 'pages/components/ParentBox';
// import { repeatEffect, settingsConfig } from 'utils/commonFunc';
// import ApiService from 'services/ApiService';
// import AlignCenterBox from 'components/AlignCenterBox';
// import { ResponsivePie } from '@nivo/pie';

// const PieDemo = ({ chartData, title }) => {
//     if (!chartData) return null;

//     const total = chartData.reduce((acc, cur) => acc + cur.value, 0);
//     const percentage = total > 0 ? ((chartData[0].value / total) * 100).toFixed(1) : '0.0';

//     return (
//         <Box sx={{ position: 'relative', width: 550, height: 520 }}>
//             {/* 상단 텍스트 영역 */}
//             {title && (
//                 <Box sx={{ position: 'absolute', top: 20, left: 0, width: '100%', zIndex: 10 }}>
//                     <AlignCenterBox>
//                         <Typography variant="h2" textAlign="center">{title}</Typography>
//                         <Typography variant="h3" textAlign="center" color="limegreen">
//                             {percentage}%
//                         </Typography>
//                     </AlignCenterBox>
//                 </Box>
//             )}

//             {/* 파이 차트 */}
//             <ResponsivePie
//                 data={chartData}
//                 theme={{
//                     text: {
//                         fontSize: '2em',
//                         fontWeight: '300',
//                         fill: '#FFFFFF',
//                     }
//                 }}
//                 sortByValue
//                 margin={{ top: 100, right: 50, bottom: 80, left: 50 }}
//                 colors={[green[600], red[700]]}
//                 padAngle={0}
//                 cornerRadius={0}
//                 innerRadius={0}
//                 enableArcLabels={true}
//                 arcLabel={d => d.id === '정상' ? `정상: ${d.value}` : ''}
//                 arcLabelsSkipAngle={10}
//                 arcLabelsTextColor="#ffffff"
//                 arcLinkLabel={d => `${d.id}: ${d.value}`}
//                 activeOuterRadiusOffset={5}
//                 arcLinkLabelsSkipAngle={1}
//                 arcLinkLabelsDiagonalLength={30}
//                 arcLinkLabelsTextColor="#ffffff"
//                 arcLinkLabelsThickness={4}
//                 arcLinkLabelsColor={{ from: 'color' }}
//                 isInteractive={false}
//             />
//             {/* <ResponsivePie
//                 data={chartData}
//                 theme={{
//                     text: {
//                         fontSize: '2.5em',
//                         fontWeight: '300',
//                         fill: '#FFFFFF',
//                     }
//                 }}
//                 sortByValue
//                 margin={{ top: 130, right: 50, bottom: 70, left: 50 }}
//                 colors={[green[600], red[700]]}
//                 padAngle={0}
//                 cornerRadius={0}
//                 innerRadius={0}
//                 startAngle={180}
//                 endAngle={-180}
//                 enableArcLabels={true}
//                 arcLabel={d => d.id === '정상' ? `정상: ${d.value}` : ''}
//                 arcLabelsSkipAngle={10}
//                 arcLabelsTextColor="#ffffff"

//                 arcLinkLabel={d => d.id === '장애' ? `${d.id}: ${d.value}` : ''}
//                 arcLinkLabelsSkipAngle={0}
//                 arcLinkLabelsTextColor={d => d.id === '장애' ? '#ffffff' : 'transparent'}
//                 arcLinkLabelsThickness={d => d.id === '장애' ? 4 : 0}
//                 arcLinkLabelsColor={d => d.id === '장애' ? { from: 'color' } : 'transparent'}

//                 activeOuterRadiusOffset={5}
//                 isInteractive={false}
//             /> */}


//         </Box>
//     );
// };


// // const PieDemo = ({ chartData, title }) => {
// //     if (!chartData) return null;

// //     // 장애가 0이면 제거
// //     const filteredData = chartData.filter(d => !(d.id === '장애' && d.value === 0));

// //     const total = filteredData.reduce((acc, cur) => acc + cur.value, 0);
// //     const percentage = total > 0 ? ((filteredData.find(d => d.id === '정상')?.value || 0) / total * 100).toFixed(1) : '0.0';

// //     return (
// //         <Box sx={{ position: 'relative', width: 550, height: 520 }}>
// //             {title && (
// //                 <Box sx={{ position: 'absolute', top: 20, left: 0, width: '100%', zIndex: 10 }}>
// //                     <AlignCenterBox>
// //                         <Typography variant="h2" textAlign="center">{title}</Typography>
// //                         <Typography variant="h3" textAlign="center" color="limegreen">
// //                             {percentage}%
// //                         </Typography>
// //                     </AlignCenterBox>
// //                 </Box>
// //             )}

// //             <ResponsivePie
// //                 data={filteredData}
// //                 theme={{
// //                     text: {
// //                         fontSize: '2.5em',
// //                         fontWeight: '300',
// //                         fill: '#FFFFFF',
// //                     }
// //                 }}
// //                 sortByValue
// //                 margin={{ top: 130, right: 50, bottom: 70, left: 50 }}
// //                 colors={[green[600], red[700]]}
// //                 padAngle={0}
// //                 cornerRadius={0}
// //                 innerRadius={0}
// //                 startAngle={180}
// //                 endAngle={-180}
// //                 enableArcLabels={true}
// //                 arcLabel={d => d.id === '정상' ? `정상: ${d.value}` : ''}
// //                 arcLabelsSkipAngle={10}
// //                 arcLabelsTextColor="#ffffff"
// //                 arcLinkLabel={d => d.id === '장애' ? `${d.id}: ${d.value}` : ''}
// //                 arcLinkLabelsSkipAngle={0}
// //                 arcLinkLabelsTextColor={d => d.id === '장애' ? '#ffffff' : 'transparent'}
// //                 arcLinkLabelsThickness={d => d.id === '장애' ? 4 : 0}
// //                 arcLinkLabelsColor={d => d.id === '장애' ? { from: 'color' } : 'transparent'}
// //                 activeOuterRadiusOffset={5}
// //                 isInteractive={false}
// //             />
// //         </Box>
// //     );
// // };

// const GridTextDisplayComponent = ({ checked, data }) => {
//     return (
//         data &&
//         <Stack sx={{ height: '100%', width: '90%' }}
//             direction="column"
//             justifyContent="center"
//             alignItems="center"
//             spacing={3}>
//             <Zoom in={checked}>
//                 <Box sx={{ width: '100%', height: '90%' }}>
//                     <PieDemo chartData={data.chartData} title={data.title} />
//                 </Box>
//             </Zoom>
//         </Stack>
//     );
// };

// export default function BisFacilityStatusView() {
//     const [currentData, setCurrentData] = React.useState();
//     const [checked] = React.useState(true);

//     React.useEffect(() => {
//         return repeatEffect(
//             async () => {
//                 const response = await ApiService.get("dashboard/bis/GetFacilityStatus");
//                 if (response.status === 200) {
//                     const data = response.data;
//                     if (data) {
//                         const created = [
//                             {
//                                 title: 'LED',
//                                 chartData: [
//                                     { id: '정상', value: data.ledUseCnt },
//                                     { id: '장애', value: data.ledCommFail }
//                                 ],
//                                 value1: data.ledDoorOpen,
//                                 value2: data.procLedErr,
//                                 value3: data.ledMonFail
//                             },
//                             {
//                                 title: 'LCD',
//                                 chartData: [
//                                     { id: '정상', value: data.lcdUseCnt },
//                                     { id: '장애', value: data.lcdCommFail }
//                                 ],
//                                 value1: data.lcdDoorOpen,
//                                 value2: data.procLcdErr,
//                                 value3: data.lcdMonFail
//                             },
//                             {
//                                 title: 'KIOSK',
//                                 chartData: [
//                                     { id: '정상', value: data.kioskUseCnt },
//                                     { id: '장애', value: data.kioskCommFail }
//                                 ],
//                                 value1: data.kioskDoorOpen,
//                                 value2: data.procKioskErr,
//                                 value3: data.kioskMonFail
//                             }
//                         ];
//                         setCurrentData(created);
//                     }
//                 }
//             },
//             settingsConfig().contentUpdateDelaySec
//         );
//     }, []);

//     return (
//         <ParentBox title={'BIS 시설물 상태 모니터링'}>
//             <Box sx={{ height: '100%', width: '100%', p: -5 }}>
//                 <Stack sx={{ height: '100%', width: '100%' }}
//                     direction="row"
//                     justifyContent="center"
//                     alignItems="center"
//                     spacing={1}>
//                     <GridTextDisplayComponent data={currentData && currentData[0]} checked={checked} />
//                     <GridTextDisplayComponent data={currentData && currentData[1]} checked={checked} />
//                     <GridTextDisplayComponent data={currentData && currentData[2]} checked={checked} />
//                 </Stack>
//             </Box>
//         </ParentBox>
//     );
// }
